/**
 * Great-circle (straight-line) distance in kilometres between two lat/lng
 * points, via the haversine formula. Returns null if any coordinate is
 * missing so callers can hide a distance label rather than show a wrong one.
 */
export const haversineKm = (
  aLat: number | null | undefined,
  aLng: number | null | undefined,
  bLat: number | null | undefined,
  bLng: number | null | undefined,
): number | null => {
  if (aLat == null || aLng == null || bLat == null || bLng == null) {
    return null;
  }

  const EARTH_RADIUS_KM = 6371;
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(bLat - aLat);
  const dLng = toRad(bLng - aLng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(h));
};
